import { render, staticRenderFns } from "./TerminalCreate.vue?vue&type=template&id=137bccfe"
import script from "./terminalCreate.ts?vue&type=script&lang=js&external"
export * from "./terminalCreate.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports